module.exports = __webpack_public_path__ + "static/img/comp.7e72b4bd.png";